import { render, staticRenderFns } from "./loadingTable.vue?vue&type=template&id=90145be8&scoped=true&"
import script from "./loadingTable.vue?vue&type=script&lang=js&"
export * from "./loadingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90145be8",
  null
  
)

export default component.exports